import React, { useEffect, useState, useRef } from 'react';
import { StyledDiv, headerContainer, displaySubTitle, displayTitle, moduleContainer, iconContainer, iconStyle, moduleContainerDrawer, fadeout, moreContainer, } from './Section.style';
import Button from '@mui/material/Button';
import { useTheme } from '@material-ui/core/styles';
import FormControl from "@mui/material/FormControl";
import Box from '@mui/material/Box';
import { InfoFilled, ExpandLess, ExpandMore } from '@next-common/material-ui-icons';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import LanguageIcon from '@mui/icons-material/Language';
import SettingsIcon from '@mui/icons-material/Settings';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import ConstructionIcon from '@mui/icons-material/Construction';
import WarningIcon from '@mui/icons-material/Warning';
import { Drawer } from '../Drawer';
const MAXHEIGHT = 300;
const MAPPING_ICONE = {
    info: InfoFilled,
    language: LanguageIcon,
    list: FormatListBulletedIcon,
    menuBook: MenuBookIcon,
    equalizer: EqualizerIcon,
    settings: SettingsIcon,
    construction: ConstructionIcon,
    warning: WarningIcon,
};
export const Section = ({ children, title, fontSize, subTitle = '', col = 1, icon = 'info' }) => {
    const [expanded, setExpanded] = useState(false);
    //drawer
    const [open, setOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const theme = useTheme();
    const [moduleContainerHeight, setModuleContainerHeight] = useState(0);
    const moduleContainerRef = useRef(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const childModule = (children) => {
        return React.Children.map(children, (child, index) => (React.createElement("div", { key: index, style: {
                flex: `0 0 ${100 / (isMobile ? 1 : col)}%`,
                boxSizing: 'border-box',
                marginTop: '24px',
                paddingRight: isMobile || col === 1 ? 0 : '16px',
            } }, child)));
    };
    useEffect(() => {
        setTimeout(() => {
            if (moduleContainerRef.current) {
                const { clientHeight, style } = moduleContainerRef.current;
                if (clientHeight > MAXHEIGHT) {
                    setModuleContainerHeight(clientHeight);
                    style.maxHeight = `${MAXHEIGHT}px`;
                }
            }
        }, 1000);
    }, [moduleContainerRef.current]);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < theme.breakpoints.values['sm']);
        };
        if (typeof window !== 'undefined') {
            handleResize();
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const toggleDrawer = () => {
        setExpanded(!expanded);
        if (isMobile) {
            setOpen(!open);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const currentContainer = moduleContainerRef.current;
            currentContainer.style.maxHeight = !expanded ? null : `${MAXHEIGHT}px`;
        }
    };
    return (React.createElement(StyledDiv, { isMobile: isMobile },
        React.createElement("div", { style: headerContainer },
            React.createElement("div", { style: iconContainer },
                !MAPPING_ICONE[icon] && React.createElement(InfoFilled, { style: iconStyle }),
                React.createElement(MAPPING_ICONE[icon] ? MAPPING_ICONE[icon] : 'info', { style: iconStyle })),
            React.createElement("div", null,
                React.createElement(Box, { sx: displayTitle, fontSize: fontSize }, title),
                React.createElement(Box, { sx: displaySubTitle }, subTitle))),
        React.createElement("div", { ref: moduleContainerRef, style: Object.assign(Object.assign({}, moduleContainer), { overflow: 'hidden', flexWrap: 'wrap' }) },
            moduleContainerHeight > MAXHEIGHT && !expanded && React.createElement("div", { style: Object.assign(Object.assign({}, fadeout), { height: MAXHEIGHT, position: 'absolute' }) }),
            childModule(children)),
        moduleContainerHeight > MAXHEIGHT && (React.createElement("div", { style: Object.assign(Object.assign({}, moreContainer), { textAlign: 'center' }) },
            React.createElement(Button, { "data-qa": "open-drawer", onClick: toggleDrawer, color: "secondary", variant: "outlined", endIcon: isMobile ? React.createElement(ExpandLess, { sx: { transform: 'rotate(90deg)' } }) : expanded ? React.createElement(ExpandLess, null) : React.createElement(ExpandMore, null) }, isMobile ? 'Voir tout' : expanded ? 'Afficher moins' : 'Afficher plus'))),
        isMobile && (React.createElement(Drawer, { "data-qa": "drawer", title: title, open: open, onClose: close, content: React.createElement(React.Fragment, null,
                React.createElement(Box, { sx: { flex: 2 } },
                    React.createElement(FormControl, { sx: { margin: 0 } },
                        React.createElement("div", { style: Object.assign(Object.assign({}, moduleContainerDrawer), { flexWrap: 'wrap' }) }, childModule(children))))) }))));
};
